type OnCopyType = {
    value: string, 
    showSuccessToast: () => void, 
    showErrorToast: () => void
}
export async function onCopyText({ value, showErrorToast, showSuccessToast }: OnCopyType) {
    await navigator.clipboard.writeText(value)
        .then(() => showSuccessToast())
        .catch(() => showErrorToast())
}